import React, { useState } from 'react'
import { useFindMenu, useLocale, useTrans } from 'hooks'
import { Close, Logo, Menu, Search, ArrowUp, ArrowDown, ArrowLeft } from '@components/icons'
import { ButtonRounded, LangDropdown, WContainer, WLink } from 'components/atoms'
import { NavDropdown } from '@components/molecules'
import { NavMobile, SearchModal } from '@components/organisms'
import styles from './Header.module.sass'
import { menusMock } from '@utils/mock'
import LogoEmilamerica25 from '@components/icons/LogoEmilamerica25'
//import { trackingGAevent, uniformData } from '@utils/gtm'

interface Props {
  item?: any
  langs?: any[]
  className?: string
  transparentHeader?: boolean
}

const Header = (props: Props) => {
  const { item, langs = [], className = '', transparentHeader = false } = props

  const t = useTrans()

  const [openItem, setOpenItem] = useState(null)
  const [searchOpen, setSearchOpen] = useState(false)
  const [navMobileOpen, setNavMobileOpen] = useState(false)
  const [openItemMobile, setOpenItemMobile] = useState(null)

  const topMenu = useFindMenu('top')
  const navMenu = useFindMenu('main')
  const { isAmerica } = useLocale()

  const handleClickHeader = (label: string) => {
    // trackingGAevent('header', {
    //   searchTerm: '',
    //   position: '',
    //   label: uniformData(label),
    //   product: '',
    //   method: '',
    //   type: '',
    // })
  }

  const handleClickMenu = (label: string, position: string, type: string) => {
    // trackingGAevent('menu', {
    //   searchTerm: '',
    //   position: uniformData(position),
    //   label: uniformData(label),
    //   product: '',
    //   method: '',
    //   type: uniformData(type),
    // })
  }

  return (
    <>
      <header
        className={`${styles.root} ${!!openItem ? styles['root--dropdownOpen'] : ''} ${
          navMobileOpen ? styles['root--navMobileOpen'] : ''
        } ${searchOpen ? styles['root--searchOpen'] : ''} ${
          transparentHeader ? styles['root--transparentHeader'] : ''
        } ${className}`}
      >
        <div className={styles.top}>
          <WContainer>
            <ul className={styles.topMenu}>
              {topMenu?.children?.map((x) => (
                <li key={x.pk} className={styles.topItem}>
                  <WLink href={x.url} className={styles.topLink}>
                    {x.name}
                  </WLink>
                </li>
              ))}
            </ul>
          </WContainer>
        </div>
        <div className={styles.main}>
          <WContainer>
            <div className={styles.layout}>
              <WLink
                href={'/'}
                className={styles.logo}
                ariaLabel={item?.chiave === 'homepage' ? undefined : t('Logo')}
                onClick={() => handleClickHeader('logo')}
              >
                {item?.chiave === 'homepage' ? (
                  <h1 aria-label={isAmerica ? 'Emilamerica' : 'Emilgroup'}>
                    <span style={{ display: 'none' }}>
                      {isAmerica ? 'Emilamerica' : 'Emilgroup'}
                    </span>
                    {isAmerica ? (
                      <LogoEmilamerica25 idVariant="headerhome" />
                    ) : (
                      <Logo idVariant="headerhome" />
                    )}
                  </h1>
                ) : isAmerica ? (
                  <LogoEmilamerica25 idVariant="header" />
                ) : (
                  <Logo idVariant="header" />
                )}
              </WLink>
              {!!navMenu?.children?.length && (
                <nav className={styles.nav}>
                  <ul role="menubar">
                    {navMenu?.children?.map((x) => (
                      <li
                        key={x.pk}
                        role="menuitem"
                        className={`${styles.item} ${x.key ? styles[`item--${x.key}`] : undefined}`}
                      >
                        {x.children?.length ? (
                          <>
                            <button
                              onClick={(e) => {
                                e.stopPropagation()
                                setOpenItem(openItem?.pk === x?.pk ? null : x)
                                if (searchOpen) {
                                  setSearchOpen(false)
                                }
                                handleClickMenu(x.name, 'first_level_menu', '')
                              }}
                              className={`${styles.trigger} ${styles['trigger--button']} ${
                                openItem === x ? styles['trigger--open'] : ''
                              }`}
                            >
                              <span className={styles.triggerLabel}>{x.name} </span>
                              <span className={styles.triggerIcon}>
                                {openItem === x ? <ArrowUp /> : <ArrowDown />}
                              </span>
                            </button>
                            <NavDropdown
                              item={x}
                              open={openItem?.pk === x?.pk}
                              setOpen={(v) => setOpenItem(v ? x : null)}
                            />
                          </>
                        ) : (
                          <WLink
                            href={x.url}
                            newPage={x.blank}
                            className={`${styles.trigger} ${styles['trigger--link']}`}
                            onClick={() => handleClickMenu(x.name, 'first_level_menu', '')}
                          >
                            {x.name}
                          </WLink>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
              )}
              <div className={styles.actions}>
                <ButtonRounded
                  icon={<Search />}
                  mobileHeaderIcon={searchOpen ? <Close /> : <Search />}
                  size="md"
                  mobileHeaderSize="sm"
                  theme="neutral20"
                  ariaLabel={t(searchOpen ? 'Chiudi ricerca' : 'Apri ricerca')}
                  onClick={() => {
                    !searchOpen && handleClickHeader('search')
                    setSearchOpen(!searchOpen)
                    if (openItem) {
                      setOpenItem(null)
                    } else if (navMobileOpen) {
                      setNavMobileOpen(false)
                    }
                  }}
                  className={`${styles.searchTrigger} headerSearchTrigger`} // .headerSearchTrigger serve per gestire l'outside click in SearchModal
                />
                <button
                  type="button"
                  aria-label={t(navMobileOpen ? 'Chiudi menu' : 'Apri menu')}
                  onClick={(e) => {
                    e.stopPropagation()
                    !navMobileOpen && handleClickHeader('burger_menu')
                    setNavMobileOpen(!navMobileOpen)
                    setOpenItemMobile(null)
                    if (searchOpen) {
                      setSearchOpen(false)
                    }
                  }}
                  className={styles.navMobileTrigger}
                >
                  {navMobileOpen ? <Close /> : <Menu />}
                </button>
                {!!langs?.length && (
                  <LangDropdown
                    items={langs}
                    className={styles.langs}
                    onClick={(label) => handleClickHeader(label)}
                    position="header"
                  />
                )}
              </div>
            </div>
          </WContainer>
        </div>
        <NavMobile
          openItem={openItemMobile}
          setOpenItem={setOpenItemMobile}
          item={navMenu}
          bottomItem={topMenu}
          langs={langs}
          open={navMobileOpen}
          setOpen={setNavMobileOpen}
        />
        <SearchModal
          open={searchOpen}
          searchToggle={() => setSearchOpen((prev) => !prev)}
          closeSearch={() => setSearchOpen(false)}
          className={styles.searchModal}
        />
      </header>
    </>
  )
}

export default Header
